export default __webpack_public_path__ + "static/media/friendsManagerImage1.43ffcac6.png";